import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AssetFilter, isQuery } from 'app/services/assets/asset-filter.service';

@Pipe({
    name: 'filterDisplay',
})
export class FilterDisplayPipe implements PipeTransform {

    private supportedTypes = ['costcentre', 'assetcategory', 'assetgroup', 'assettype'];

    constructor(private i18n: TranslateService) {}

    transform(filter: AssetFilter): { names: string[]; type: string; }[] {
        if (!filter) {
            return [];
        }
        return Object.entries(filter)
            .filter(([type, filterItem]) => filterItem && this.supportedTypes.includes(type))
            .map(([type, filterItem]) => {
                let names: string[] = [];
                if (isQuery(filterItem)) {
                    names.push(filterItem.display);
                } else {
                    names = filterItem?.queries.map(query => query.display) || [];
                }

                switch (type) {
                    case 'costcentre':
                        return {
                            type: this.i18n.instant('STATUS.LIST.ACTION.COST_CENTRE'),
                            names
                        };

                    case 'assetcategory':
                        return {
                            type: this.i18n.instant('STATUS.LIST.ACTION.ASSET_CATEGORY'),
                            names
                        };

                    case 'assetgroup':
                        return {
                            type: this.i18n.instant('STATUS.LIST.ACTION.ASSET_GROUP'),
                            names
                        };

                    case 'assettype':
                        return {
                            type: this.i18n.instant('STATUS.LIST.ACTION.ASSET_TYPE'),
                            names
                        };
                }
            });
    }
}
